import { GET, POST, PUT } from "./_config";

export const getCompanyListApi = async (query: string) =>
  await GET(`/super-admin/company/list?${query || ""}`, true);

export const createCompanyApi = async (body: any) =>
  await POST(`/super-admin/company/create-company`, body, true);

export const getCompanyByIdApi = async (adminId: string) =>
  await GET(`/super-admin/company/${adminId}`, true);

export const updateCompanyDetailsApi = async (adminId: string, body: any) =>
  await PUT(`/super-admin/company/${adminId}`, body, true);

export const updatePasswordApi = async (body: any) =>
  await POST(`/super-admin/company/update-password`, body, true);

export const updateCompanyStatusApi = async (body: any) =>
  await POST(`/super-admin/company/update-status`, body, true);
